module.exports = __webpack_public_path__ + "static/qoutes-arb-5287809e7f4b2db0dfe9037c612a0adf.png";